export enum KillDataConfigColumnDataSource {
  MANUAL_IMPORT = 'Manual Import',
  SESSION_UPLOAD = 'Session Upload'
}